import { preloadAccessRequestSettings } from '@confluence/access-requests/entry-points/preloadAccessRequestSettings.ts';
import { waitForAllReturnWhenError } from '@confluence/query-preloader-tools/entry-points/waitForAllReturnWhenError.ts';
import { preloadSpaceRestrictionCheck } from '@confluence/restrictions/entry-points/preloadSpaceRestrictionCheck.ts';

export const preloadCommonDataForRouteWithSpaceKey = async (spaceKey: string): Promise<any> => {
	return waitForAllReturnWhenError([
		preloadSpaceRestrictionCheck(spaceKey),
		// Any route with a space key can land on RestrictedSpaceScreen, so this belongs here rather
		// than in individual route preloaders. Gating it on __SPACE_RESTRICTED_CHECK_ERROR__ was
		// tried and reverted — that global isn't reliably set by the time this task reads it.
		preloadAccessRequestSettings(),
	]);
};
